import imgLogo from "../../../assets/new_ui_img/geoparking_logo.svg";

export default function GeoLogo({ className = "h-[39px] w-auto" }) {
  return (
    <img
      src={imgLogo}
      alt="GeoParking Technologies"
      className={className}
    />
  );
}
